if (!customElements.get("header-contact")) {
  class HeaderContact extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        return;
      }
      this.initialized = true;

      this.button = this.querySelector(".head-contact-toggle");
      this.panel = this.querySelector(".head-contact-panel");

      this.button.addEventListener("click", () => {
        if (this.panel.hidden) {
          this.open();
        } else {
          this.close();
        }
      });

      document.addEventListener("click", (event) => {
        if (!this.contains(event.target)) {
          this.close();
        }
      });

      this.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          this.close();
          this.button.focus();
        }
      });

      window.addEventListener("resize", () => this.close());
    }

    open() {
      // On narrow screens keep the panel inside the viewport.
      if (window.innerWidth < 750) {
        const rect = this.button.getBoundingClientRect();
        const offset = window.innerWidth - rect.right - 15;
        this.panel.style.right = `${-offset}px`;
      } else {
        this.panel.style.right = "";
      }

      this.panel.hidden = false;
      this.button.setAttribute("aria-expanded", "true");
      this.classList.add("is-open");
    }

    close() {
      this.panel.hidden = true;
      this.button.setAttribute("aria-expanded", "false");
      this.classList.remove("is-open");
    }
  }

  customElements.define("header-contact", HeaderContact);
}
